import { render, staticRenderFns } from "./Chicken404.vue?vue&type=template&id=2fd9e6ed&"
import script from "./Chicken404.vue?vue&type=script&lang=js&"
export * from "./Chicken404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports